import Constants, { fixProtocol } from '../../../../constants/constants';

import { httpGet } from '../../../../modules/api/axios_api';

export const getRegionalUtilizationReport = async (startDate, endDate, aggregation) => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/reports/utilization-by-facility`);

  // Append the start and end dates as query parameters
  url.searchParams.append('start_date', startDate);
  url.searchParams.append('end_date', endDate);
  url.searchParams.append('aggregation', aggregation);

  return httpGet(url.toString())
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw new Error('Error getting regional utilization report', error);
    });
};
